import { Dispatch, JSX, SetStateAction, UIEvent, ReactElement, useEffect, useState, useRef } from 'react';
import { BottomSheet as ReactBottomSheet } from 'react-spring-bottom-sheet';
import { RefHandles, SpringEvent } from 'react-spring-bottom-sheet/dist/types';

import 'react-spring-bottom-sheet/dist/style.css';
import './BottomSheet.css';

export function BottomSheet({
  children,
  header,
  setClosed,
  isBottomSheetUp,
  setBottomSheetUp,
  routeTab,
}: {
  children: ReactElement | undefined;
  header?: JSX.Element | undefined;
  setClosed: () => void;
  isBottomSheetUp?: boolean;
  setBottomSheetUp: Dispatch<SetStateAction<boolean>>;
  routeTab?: boolean;
}) {
  const sheetRef = useRef<RefHandles | null>(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const newSnapPoint = 69;

  function handleScroll(e: UIEvent<HTMLDivElement>) {
    const target = e.currentTarget;
    setIsAtTop(target.scrollTop <= 0);
  }

  useEffect(() => {
    if (isBottomSheetUp && sheetRef.current?.height === newSnapPoint) sheetRef.current?.snapTo(280);
  }, [isBottomSheetUp]);

  return (
    <ReactBottomSheet
      ref={sheetRef}
      open={true}
      onDismiss={() => {
        setClosed();
        sheetRef.current?.snapTo(newSnapPoint);
      }}
      className={routeTab ? 'routes-summary-header' : ''}
      scrollLocking={false}
      blocking={false}
      defaultSnap={400}
      snapPoints={({ maxHeight }) => [newSnapPoint, 280, maxHeight - 130]}
      expandOnContentDrag={isAtTop}
      header={header}
      onSpringStart={(event: SpringEvent) => {
        if (event.type === 'SNAP' && sheetRef.current && sheetRef.current.height !== newSnapPoint) {
          setBottomSheetUp(false);
        }
      }}
      onSpringEnd={(event: SpringEvent) => {
        if (event.type === 'SNAP' && sheetRef.current) {
          if (sheetRef.current.height === newSnapPoint) {
            setBottomSheetUp(false);
          } else {
            if (!isBottomSheetUp) setBottomSheetUp(true);
          }
        }
      }}
      data-qa-element-id="bottom_sheet"
    >
      <div onScroll={handleScroll}>{children}</div>
    </ReactBottomSheet>
  );
}
